import * as React from 'react';

import RetentionPolicyModifiable32 from './RetentionPolicyModifiable32';

export const retentionPolicyModifiable32 = () => <RetentionPolicyModifiable32 />;

export default {
    title: 'Icon/Content/RetentionPolicyModifiable32',
    component: RetentionPolicyModifiable32,
    parameters: {
        notes:
            "`import RetentionPolicyModifiable32 from 'box-ui-elements/es/icon/content/RetentionPolicyModifiable32';`",
    },
};
